/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentProvider = {
    UNINTEGRATED: 'UNINTEGRATED',
    ADYEN: 'ADYEN',
    SOFTPAY: 'SOFTPAY',
    NETS: 'NETS'
} as const;
export type PaymentProvider = typeof PaymentProvider[keyof typeof PaymentProvider];


export function instanceOfPaymentProvider(value: any): boolean {
    for (const key in PaymentProvider) {
        if (Object.prototype.hasOwnProperty.call(PaymentProvider, key)) {
            if (PaymentProvider[key as keyof typeof PaymentProvider] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentProviderFromJSON(json: any): PaymentProvider {
    return PaymentProviderFromJSONTyped(json, false);
}

export function PaymentProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentProvider {
    return json as PaymentProvider;
}

export function PaymentProviderToJSON(value?: PaymentProvider | null): any {
    return value as any;
}

export function PaymentProviderToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentProvider {
    return value as PaymentProvider;
}

